import { render } from "./SingleColorSelector.vue?vue&type=template&id=27735136&scoped=true"
import script from "./SingleColorSelector.vue?vue&type=script&lang=js"
export * from "./SingleColorSelector.vue?vue&type=script&lang=js"

import "./SingleColorSelector.vue?vue&type=style&index=0&id=27735136&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27735136"]])

export default __exports__